
import ViewIcon from "../../../assets/svg/icono_prefactura.svg";
import DownIcon from "../../../assets/svg/icono_descargar_reporte.svg";
import SendIcon from "../../../assets/svg/icono_send.svg";
import AddIcon from "../../../assets/svg/icono_agregar_blue.svg";

type BtnCreateProps ={
  txtBtn:string ,    
  id?:number,
  funcExec:(id:number)=> void,
  disabledBtn?:boolean
  icon?:string
}

const BtnsEvalResult = ({txtBtn,id=0,funcExec,disabledBtn=false,icon}:BtnCreateProps) => {

  return (
    <>
    { disabledBtn ? 
      <button
      className="performCol_botonInactive"
      disabled             
      >   
     <div className="alineacionBoton">  
       {icon==='eye' ?
       <img src={ViewIcon} alt="" />
       :icon ==='download'?
       <img src={DownIcon} alt="" />
       :icon ==='add'? 
       <img src={AddIcon} alt="" />  
       :
       <img src={SendIcon} alt="" />  
       }
           <div className="nombrePrestacion">
            <b><span>{txtBtn}</span> </b>
           </div>
     </div>
    </button>
    :
     <button
      onClick={()=>funcExec(id)}
     className="btnNuevaPrestacion"
       >
       <div className="alineacionBoton">
       {icon==='eye' ?
       <img src={ViewIcon} alt="" />
       :icon ==='download'?
       <img src={DownIcon} alt="" />
       :icon ==='add' ?
        <img src={AddIcon} alt="" />
       :<img src={SendIcon} alt="" />  
       }
        <div className="nombrePrestacion">
           <b><span>{txtBtn}</span> </b>
         </div>
       </div>
     </button>   
    }
    </>
  )
}

export default BtnsEvalResult
